var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 1.5C2.33325 1.5 0.909919 2.53667 0.333252 4C0.909919 5.46333 2.33325 6.5 3.99992 6.5C5.66659 6.5 7.08992 5.46333 7.66659 4C7.08992 2.53667 5.66659 1.5 3.99992 1.5ZM3.99992 5.66667C3.07992 5.66667 2.33325 4.92 2.33325 4C2.33325 3.08 3.07992 2.33333 3.99992 2.33333C4.91992 2.33333 5.66659 3.08 5.66659 4C5.66659 4.92 4.91992 5.66667 3.99992 5.66667ZM3.99992 3C3.44659 3 2.99992 3.44667 2.99992 4C2.99992 4.55333 3.44659 5 3.99992 5C4.55325 5 4.99992 4.55333 4.99992 4C4.99992 3.44667 4.55325 3 3.99992 3Z",
    fill: "white",
    fillOpacity: 0.27
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.220c40f5248f8b4ea28fce949a9253cd.svg";
export { ForwardRef as ReactComponent };